export const LANDING = {
  signInBtn: "landing-google-signin-btn",
  brand: "landing-brand",
};

export const ONBOARDING = {
  timeInput: "onboarding-time-input",
  tzSelect: "onboarding-tz-select",
  submitBtn: "onboarding-submit-btn",
  stepIndicator: "onboarding-step-indicator",
};

export const DASHBOARD = {
  root: "dashboard-root",
  runNowBtn: "dashboard-run-now-btn",
  openSheetBtn: "dashboard-open-sheet-btn",
  totalCard: "dashboard-total-card",
  nextRunCard: "dashboard-next-run-card",
  lastRunCard: "dashboard-last-run-card",
  needsReplyCard: "dashboard-needs-reply-card",
};

export const LOGTABLE = {
  root: "log-table-root",
  search: "log-table-search",
  columnToggle: "log-table-column-toggle",
  row: (id) => `log-row-${id}`,
  emailLink: (id) => `log-row-${id}-email-link`,
  statusSelect: (id) => `log-row-${id}-status-select`,
  notesInput: (id) => `log-row-${id}-notes-input`,
};

export const RUNS = {
  root: "runs-root",
  row: (id) => `run-row-${id}`,
};

export const SETTINGS = {
  root: "settings-root",
  timeInput: "settings-time-input",
  tzSelect: "settings-tz-select",
  saveBtn: "settings-save-btn",
  pauseBtn: "settings-pause-btn",
  disconnectBtn: "settings-disconnect-btn",
};

export const SHELL = {
  sidebar: "app-sidebar",
  navDashboard: "nav-dashboard",
  navLog: "nav-log",
  navRuns: "nav-runs",
  navSettings: "nav-settings",
  logoutBtn: "shell-logout-btn",
};
